import { MouseEvent, ReactElement, useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { InfoPopover, InfoPopoverItem } from '../InfoPopover';

export type PowerAssetDetail = {
  label: string;
  value: string | number | null | undefined;
  // Renders a dot in front of the value, coloured from the asset's status.
  showStatusDot?: boolean;
  dotColor?: string;
};

export type PowerAssetChipProps = {
  name: string;
  icon?: ReactElement;
  statusIcon?: ReactElement;
  statusColor?: string;
  details: PowerAssetDetail[];
  testId: string;
};

// Shared chip + details popover for both power input and power output diagram assets.
export function PowerAssetChip({ name, icon, statusIcon, statusColor, details, testId }: PowerAssetChipProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Chip
        size="large"
        color="accent"
        icon={icon}
        label={
          <Stack direction="row" alignItems="center" gap={1}>
            <span>{name}</span>
            {statusIcon}
          </Stack>
        }
        onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
        data-testid={testId}
      />
      <InfoPopover anchorEl={anchorEl} setAnchorEl={setAnchorEl} title={name} icon={icon}>
        {details.map(({ label, value, showStatusDot, dotColor }) => (
          <InfoPopoverItem
            key={label}
            label={label}
            value={value}
            dotColor={dotColor ?? (showStatusDot ? statusColor : undefined)}
          />
        ))}
      </InfoPopover>
    </>
  );
}
